/**
 * Open a reference modal on every page-load if hash equals modal
 */
import {Utils} from "../Modules/Utils";
// @ts-ignore
import Modal from "bootstrap/js/dist/modal";

Utils.executeWhenDocumentIsReady(() => {
    if (window.location.hash) {
        const hash = window.location.hash;
        const modalElement = document.querySelector<HTMLElement>(hash);

        if (modalElement && modalElement.classList.contains("modal")) {
            const modal = new Modal(modalElement);
            modal.show();
        }
    }

    const modalToggles = document.querySelectorAll<HTMLAnchorElement>('a[data-toggle="modal"]');
    modalToggles.forEach((toggle) => {
        toggle.addEventListener("click", function () {
            window.location.hash = this.getAttribute("href") || "";
        });
    });

    function revertToOriginalURL() {
        const original = window.location.href.substring(0, window.location.href.indexOf("#"));
        history.replaceState({}, document.title, original);
    }

    const modals = document.querySelectorAll<HTMLElement>(".modal");
    modals.forEach((modal) => {
        // Still married to jQuery via Bootstrap 4.6, which is unfortunate.
        // @ts-ignore
        if (window.jQuery) {
            // @ts-ignore
            jQuery(modal).on('hidden.bs.modal', function () {
                console.log('hidden.bs.modal');
                revertToOriginalURL();
            });
        }
    });
});
